// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.testPage_Main__bwHra {
    padding-top: 80px;
    padding: 0.5em 1em 2.1em;
}

.testPage_PageName__S738B {
/* 
    font-size: 20px !important;
    line-height: 24px !important;
    font-weight: 500 !important;

*/

    margin: 40px 0 24px !important;
    color:#BABABA;
    font-style: normal;
    font-weight: 600 !important;
    font-size: 30px !important;
    line-height: 48px !important;
    text-align: center !important;
}
.testPage_BoldLabel__sQwji {
    text-transform: uppercase;
    font-size: 20px;
    line-height: 24px;
    font-weight: 500;
    margin-top: 40px;
}

.testPage_BoldLabel__sQwji p {
    font-family: "Inter" !important;
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 48px;
    text-align: center;
}

.testPage_Question__2O7n6 > * {
    margin: 0;
    font-size: 20px !important;
}
.testPage_testBelbLabel__8-FEv{
    text-transform: uppercase;
    font-family: "Benzin ExtraBold", sans-serif !important;
    text-align: center;
}

h1.testPage_testBelbLabel__8-FEv {
    text-align: left;
    font-size: 80px;
    line-height: 94px;
}
h3.testPage_testBelbLabel__8-FEv {
    margin-top: 50px;
    text-align: left;
    font-size: 30px;
    line-height: 35px;
}

section.testPage_instructionsText__x7R1u {
    margin-top: 32px;
    font-weight: 300;
    font-size: 18px;
    line-height: 22px;
    text-align: left;
}

.testPage_instructionsText__x7R1u p {
    font-family: "Inter";
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 1.1;
}

.testPage_instructionsStrongText__YT5Z3 {
    margin-bottom: 8px;
}

@media screen and (max-width: 960px) {
    .testPage_PageName__S738B {
        font-size: calc(16px + 0.2vw) !important;
    }
    .testPage_BoldLabel__sQwji {
        font-size: calc(18px + 0.1vw) !important;
    }

    .testPage_BoldLabel__sQwji p {
        font-size: calc(18px + 0.1vw) !important;
        line-height: calc(24px + 0.1vw) !important;
    }

    .testPage_Question__2O7n6 {
        font-size: 16px !important;
    }
    .testPage_testBelbLabel__8-FEv {
        font-size: 20px !important;
    }
    .testPage_instructionsText__x7R1u {
        font-size: 14px !important;
        line-height: 20px !important;
    }

    .testPage_instructionsText__x7R1u p {
        font-size: 18px !important;
    }

    h1.testPage_testBelbLabel__8-FEv {
        font-size: 30px !important;
        line-height: 1.2;
    }
    h3.testPage_testBelbLabel__8-FEv {
        font-size: 12px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/TestPage/testPage.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;AACA;;;;;CAKC;;IAEG,8BAA8B;IAC9B,aAAa;IACb,kBAAkB;IAClB,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,6BAA6B;AACjC;AACA;IACI,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,0BAA0B;AAC9B;AACA;IACI,yBAAyB;IACzB,sDAAsD;IACtD,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,wCAAwC;IAC5C;IACA;QACI,wCAAwC;IAC5C;;IAEA;QACI,wCAAwC;QACxC,0CAA0C;IAC9C;;IAEA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;QAC1B,4BAA4B;IAChC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;QAC1B,gBAAgB;IACpB;IACA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".Main {\n    padding-top: 80px;\n    padding: 0.5em 1em 2.1em;\n}\n\n.PageName {\n/* \n    font-size: 20px !important;\n    line-height: 24px !important;\n    font-weight: 500 !important;\n\n*/\n\n    margin: 40px 0 24px !important;\n    color:#BABABA;\n    font-style: normal;\n    font-weight: 600 !important;\n    font-size: 30px !important;\n    line-height: 48px !important;\n    text-align: center !important;\n}\n.BoldLabel {\n    text-transform: uppercase;\n    font-size: 20px;\n    line-height: 24px;\n    font-weight: 500;\n    margin-top: 40px;\n}\n\n.BoldLabel p {\n    font-family: \"Inter\" !important;\n    font-style: normal;\n    font-weight: 700;\n    font-size: 28px;\n    line-height: 48px;\n    text-align: center;\n}\n\n.Question > * {\n    margin: 0;\n    font-size: 20px !important;\n}\n.testBelbLabel{\n    text-transform: uppercase;\n    font-family: \"Benzin ExtraBold\", sans-serif !important;\n    text-align: center;\n}\n\nh1.testBelbLabel {\n    text-align: left;\n    font-size: 80px;\n    line-height: 94px;\n}\nh3.testBelbLabel {\n    margin-top: 50px;\n    text-align: left;\n    font-size: 30px;\n    line-height: 35px;\n}\n\nsection.instructionsText {\n    margin-top: 32px;\n    font-weight: 300;\n    font-size: 18px;\n    line-height: 22px;\n    text-align: left;\n}\n\n.instructionsText p {\n    font-family: \"Inter\";\n    font-style: normal;\n    font-weight: normal;\n    font-size: 24px;\n    line-height: 1.1;\n}\n\n.instructionsStrongText {\n    margin-bottom: 8px;\n}\n\n@media screen and (max-width: 960px) {\n    .PageName {\n        font-size: calc(16px + 0.2vw) !important;\n    }\n    .BoldLabel {\n        font-size: calc(18px + 0.1vw) !important;\n    }\n\n    .BoldLabel p {\n        font-size: calc(18px + 0.1vw) !important;\n        line-height: calc(24px + 0.1vw) !important;\n    }\n\n    .Question {\n        font-size: 16px !important;\n    }\n    .testBelbLabel {\n        font-size: 20px !important;\n    }\n    .instructionsText {\n        font-size: 14px !important;\n        line-height: 20px !important;\n    }\n\n    .instructionsText p {\n        font-size: 18px !important;\n    }\n\n    h1.testBelbLabel {\n        font-size: 30px !important;\n        line-height: 1.2;\n    }\n    h3.testBelbLabel {\n        font-size: 12px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Main": `testPage_Main__bwHra`,
	"PageName": `testPage_PageName__S738B`,
	"BoldLabel": `testPage_BoldLabel__sQwji`,
	"Question": `testPage_Question__2O7n6`,
	"testBelbLabel": `testPage_testBelbLabel__8-FEv`,
	"instructionsText": `testPage_instructionsText__x7R1u`,
	"instructionsStrongText": `testPage_instructionsStrongText__YT5Z3`
};
export default ___CSS_LOADER_EXPORT___;
